import { QUICK_ENTRY_SELECTION_KEYS } from 'features/quick-entry/constants';

export const buildFormParams = formData => ({
  candidateName: formData?.name || '',
  files:
    Array.isArray(formData?.files) &&
    formData?.files.map(file => ({
      id: file?.id,
      name: file?.file_name,
      typeId: file?.file_type_id || file?.fileType?.id,
      url: file?.url
    })),
  notes: formData?.notes || null,
  typeId: QUICK_ENTRY_SELECTION_KEYS.candidate
});

export const mapQuickEntryFiles = (files = []) => {
  return files.map(file => ({
    id: file?.id,
    file_name: file?.name,
    fileType: { id: file?.typeId },
    url: file?.url
  }));
};
